export const findConnector = (obj: { [key: string]: string | undefined }) => {
  for (const key in obj) {
    if (obj[key] !== undefined) {
      return { connectMedium: key, value: obj[key] as string };
    }
  }
};
